var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPipe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "301px",
    height: "301px",
    viewBox: "0 0 301 301",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "check-ring-round-svgrepo-com 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "check-ring-round-svgrepo-com-1",
    transform: "translate(15, 15)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.375,270.75 C210.141,270.75 270.75,210.141 270.75,135.375 C270.75,60.609 210.141,0 135.375,0 C60.609,0 0,60.609 0,135.375 C0,210.141 60.609,270.75 135.375,270.75 Z",
    id: "Path",
    fill: "#1D3241",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.375,270.75 C166.695,270.75 197.046,259.89 221.256,240.021 C245.467,220.153 262.04,192.503 268.149,161.785 C274.259,131.067 269.529,99.181 254.765,71.56 C240.002,43.9382 216.117,22.2904 187.182,10.3048 C158.246,-1.6807 126.049,-3.2624 96.078,5.8293 C66.107,14.9209 40.2153,34.1232 22.8149,60.165 C5.4147,86.206 -2.4178,117.475 0.6521,148.645 C3.7219,179.813 17.5042,208.953 39.6506,231.1",
    id: "Path",
    stroke: "#43BC96",
    strokeWidth: 30,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.542,105.292 L141.422,170.234 C131.562,182.067 126.631,187.985 120.004,188.286 C113.377,188.585 107.932,183.14 97.04,172.248 L75.208,150.417",
    id: "Path",
    stroke: "#43BC96",
    strokeWidth: 30,
    strokeLinecap: "round"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipe);
export default __webpack_public_path__ + "static/media/pipe.bbf503fcff195ad87474589d1a3d6f92.svg";
export { ForwardRef as ReactComponent };